module.exports = __webpack_public_path__ + "img/rune-dd.946614e5.png";